import { CreateEscrowPaymentRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateCreateEscrowPayment = makeValidator({
  FieldParser: CreateEscrowPaymentRow,
});
